module.exports = __webpack_public_path__ + "img/premium.9849a83.gif";